import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var selectionAnalyticsPluginKey = new PluginKey('selectionAnalyticsPluginKey');
export var createSelectionAnalyticsPlugin = function createSelectionAnalyticsPlugin(dispatchAnalyticsEvent) {
  var keyActions = new Map([['c', 'copy'], ['x', 'cut'], ['z', 'undo'], ['Escape', 'escape'], ['Backspace', 'delete']]);
  var isFollowUpKey = function isFollowUpKey(event) {
    return ['c', 'x', 'z'].includes(event.key) && (event.metaKey || event.ctrlKey) || ['Escape', 'Backspace'].includes(event.key);
  };
  var dispatchEvent = function dispatchEvent(fromDepth, followedBy) {
    dispatchAnalyticsEvent({
      action: ACTION.SELECT_ALL,
      actionSubject: ACTION_SUBJECT.DOCUMENT,
      actionSubjectId: ACTION_SUBJECT_ID.ALL,
      eventType: EVENT_TYPE.TRACK,
      attributes: {
        followedBy: followedBy,
        fromDepth: fromDepth
      }
    });
  };
  return new SafePlugin({
    key: selectionAnalyticsPluginKey,
    state: {
      init: function init() {
        return {
          lastCmdAPress: 0,
          trackingCmdA: false
        };
      },
      apply: function apply(tr, state) {
        var meta = tr.getMeta(selectionAnalyticsPluginKey);
        return meta ? _objectSpread(_objectSpread({}, state), meta) : state;
      }
    },
    props: {
      handleDOMEvents: {
        keydown: function keydown(view, event) {
          var _selectionAnalyticsPl = selectionAnalyticsPluginKey.getState(view.state),
            lastCmdAPress = _selectionAnalyticsPl.lastCmdAPress,
            trackingCmdA = _selectionAnalyticsPl.trackingCmdA;
          var tr = view.state.tr;
          var depth = view.state.selection.$from.depth;
          var metaKey = event.metaKey || event.ctrlKey;
          if (event.key === 'a' && metaKey) {
            tr.setMeta(selectionAnalyticsPluginKey, {
              lastCmdAPress: Date.now(),
              trackingCmdA: true
            });
            dispatchEvent(depth);
            view.dispatch(tr);
          } else if (trackingCmdA && Date.now() - lastCmdAPress < 5000 && isFollowUpKey(event)) {
            tr.setMeta(selectionAnalyticsPluginKey, {
              trackingCmdA: false
            });
            dispatchEvent(depth, keyActions.get(event.key));
            view.dispatch(tr);
          }
          return false;
        }
      }
    }
  });
};